const ENVIRONMENTS = ['local', 'devbox', 'stage', 'prod'];
export const isEnvironment = (env = 'prod') => ENVIRONMENTS.indexOf(env) > -1;
